<template>
    <div class="auth-wrapper auth-v1 px-2">
        <div class="auth-inner py-2">
        <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-large
        rounded="sm"
      >
            <!-- Register v1 -->
            <b-card class="mb-0">
                <b-row>
                    <b-col sm="12" class="text-center">
                        <b-img fluid class="brand-logo" style="max-width:100%;" :src="client.logo" />
                    </b-col>
    
                </b-row>
                <div v-if="$route.query.action == 'debit'">
                    <b-card-title class="mb-1">
                        會員增值 Member Top-Up
                    </b-card-title>
                    <b-form-group label="會員編號 Member Code" label-for="Member Code">
                            <b-form-input id="MemberCode" :disabled="login.sent" v-model="login.member_code" trim @input="login.member_code = login.member_code ? login.member_code.toUpperCase() : ''" />
                        </b-form-group>
                        <b-form-group label="會員登記之電話號碼 Memeber Registered Mobile" label-for="Memeber Registered Mobile">
                            <b-form-input id="Mobile" v-model="login.mobile" trim @keyup.enter="otp" :disabled="login.sent" />
                        </b-form-group>
                        <b-form-group label="會員中文姓名 Member Chinese Name" label-for="MemberChineseName" v-if="login.sent === true">
                            <b-form-input id="MemberChineseName"  disabled v-model="login.zh_name"  trim />
                        </b-form-group>
                        <b-form-group label="會員英文姓名 Member English Name" label-for="MemberEnglishName" v-if="login.sent === true">
                            <b-form-input id="MemberEnglishName" disabled v-model="login.en_name"  trim />
                        </b-form-group>
                        <b-button variant="primary" block type="button" @click="check_name()"  v-if="login.sent === false" :disabled="processing">
                            <font-awesome-icon icon="fa-solid fa-check" color="#ffffff" /> 確定
                        </b-button>
                        <b-button variant="primary" block type="button" @click="goto_topup()" v-if="login.sent" :disabled="processing" >
                            <font-awesome-icon icon="fa-solid fa-check" color="#ffffff" /> 前往增值頁面
                        </b-button>
                </div>
                <div v-if="$route.query.action != 'debit'">
                    <b-card-title class="mb-1">
                        會員登入 Login
                    </b-card-title>
                        <b-form-group label="會員登記之電話號碼 Memeber Registered Mobile" label-for="Memeber Registered Mobile">
                            <b-form-input id="Mobile" v-model="login.mobile" trim @keyup.enter="otp" :disabled="login.sent" />
                        </b-form-group>
                        <b-form-group label="驗證碼 Verification Code" label-for="驗證碼 Verification Code" v-if="login.sent === true">
                            <b-form-input id="code" v-model="login.code"  trim />
                        </b-form-group>
                        <b-button variant="success" block type="button" @click="otp()"  v-if="login.sent === false" :disabled="processing">
                            <font-awesome-icon icon="fa-brands fa-whatsapp" color="#ffffff" /> 發出驗證碼
                        </b-button>
                        <b-button variant="primary" block type="button" @click="member_login()" v-if="login.sent" :disabled="processing" >
                            <font-awesome-icon icon="fa-solid fa-check" color="#ffffff" /> 登入
                        </b-button>
                </div>
                <div v-if="$route.query.action != 'debit'">
                <div class="divider my-2">
                    <div class="divider-text">
                        或
                    </div>
                </div>
                <div>
                    <b-card-title class="mb-1">
                        新註冊登記 Register
                    </b-card-title>
    
                    
                    <b-card-text class="mb-2">
                        <div v-if="insert === true" v-html="message"></div>
                    </b-card-text>
    
                    <!-- form -->
                    <validation-observer ref="registerForm">
                        <h4 class="brand-text text-primary ml-1" v-if="valid === false">Invalid Link</h4>
                        <b-form v-if="insert === false && valid === true">
                            <!-- Username -->
                            <validation-provider #default="validationContext" name="Chinese Name">
                                <b-form-group :label="'中文姓名 Chinese Name' + (isRequired('zh_name') ? ' *' : '')" label-for="Chinese Name">
                                    <b-form-input id="Chinese Name" v-model="userData.zh_name" trim />
                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider #default="validationContext" name="en_name" rules="required">
                                <b-form-group :label="'英文姓名 English Name' + (isRequired('en_name') ? ' *' : '')" label-for="en_name">
                                    <b-form-input id="en_name" v-model="userData.en_name" class="text-uppercase" trim />
                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider #default="validationContext" name="email">
                                <b-form-group :label="'電子郵件 E-Mail' + (isRequired('email') ? ' *' : '')" label-for="email">
                                    <b-form-input id="email" v-model="userData.email" trim />
                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider #default="validationContext" name="identity">
                                <b-form-group :label="'身份證明文件號碼 Identity Number' + (isRequired('identity') ? ' *' : '')" label-for="identity">
                                    <b-form-input id="identity" v-model="userData.identity" trim />
                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider #default="validationContext" name="mobile" rules="required">
                                <b-form-group :label="'手提電話 Mobile' + (isRequired('mobile') ? ' *' : '')" label-for="mobile">
                                    <b-form-input id="mobile" v-model="userData.mobile" trim />
                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider #default="validationContext" name="address">
                                <b-form-group :label="'聯絡地址 Address' + (isRequired('address') ? ' *' : '')" label-for="address">
                                    <b-form-input id="address" v-model="userData.address" trim />
                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider #default="validationContext" name="Birth">
                                <b-form-group :label="'出生日期 Birth' + (isRequired('birth') ? ' *' : '')" label-for="birth">
                                    <b-form-input id="birth" v-model="userData.birth" v-mask="'####-##-##'" placeholder="YYYY-MM-DD" trim />
                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider #default="validationContext" name="性別 Gender" rules="required">
                                <b-form-group :label="'性別 Gender' + (isRequired('gender') ? ' *' : '')" label-for="gender">
                                    <v-select v-model="userData.gender" :options="['Male 男','Female 女']" :clearable="false" input-id="gender" />
                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            
                            <b-form-group class="mt-2">
                                <b-form-checkbox v-model="userData.marketing_use" >
                                    我同意接收市場推廣資訊 <br>I agree to receive marketing materials
                                </b-form-checkbox>
                            </b-form-group>
                            <hr class="my-2"/>
                            <b-button variant="primary" block type="button" @click="submit">
                                送出 Submit
                            </b-button>
                        </b-form>
    
                    </validation-observer>
                </div></div>
                <div class="text-center mt-3"><b>Power by CloudFit</b><br><span style="font-size:8px;color:#bbb;">{{ this.membership }}</span></div>
    
            </b-card>
            <!-- /Register v1 -->
             </b-overlay>
        </div>
    </div>
</template>

<script>
import {
    ValidationProvider,
    ValidationObserver
} from 'vee-validate'
import {
    BCard,
    BLink,
    BCardTitle,
    BCardText,
    BOverlay,
    BForm,
    BImg,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    BFormInvalidFeedback
} from 'bootstrap-vue'
import router from '@/router'
import flatPickr from 'vue-flatpickr-component'

import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
    required,
    email
} from '@validations'
import {
    togglePasswordVisibility
} from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'

export default {
    components: {
        VuexyLogo,
        // BSV
        BCard,
        vSelect,
        BRow,
        BCol,
        BLink,
        BOverlay,
        BImg,
        BCardTitle,
        router,
        BCardText,
        BFormInvalidFeedback,
        BForm,
        flatPickr,
        BButton,
        BFormInput,
        BFormGroup,
        BInputGroup,
        BInputGroupAppend,
        BFormCheckbox,
        // validations
        ValidationProvider,
        ValidationObserver,
    },
    mixins: [togglePasswordVisibility],
    data() {
        return {
            membership: null,
            processing: false,
            regEmail: '',
            username: '',
            login: {
                mobile: null,
                code: null,
                sent: false
            },
            message: '',
            valid: true,
            password: '',
            loading:true,
            userData: {
                zh_name: null,
                en_name: null,
                email: null,
                hkid: null,
                mobile: null,
                address: null,
                birth: null,
                gender: null,
                marketing_use: true,
            },
            status: '',
            insert: false,
            credit_card_format: '#### #### #### ####',
            cvc_format: '###',
            client: {
                client_name: null,
                web_key: null,
                logo: null
            },

            // validation rules
            required,
            email,

            // 新增: required fields array
            requiredFields: [],
        }
    },
    computed: {
        passwordToggleIcon() {
            return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
        },
    },
    created() {
        if (this.$route.query.membership) {
            this.membership = this.$route.query.membership
        }
        this.get_center()
    },
    methods: {
        goto_topup() {
            if (this.$route.query.action == 'debit') {
                this.$router.push('/paylink/debit/' + this.login.uuid + '/').then(() => {})
            } 
        },
        member_login() {
          this.processing = true
          this.loading = true
            this.$http.post(process.env.VUE_APP_API_BASE + `/online-pay/` + router.currentRoute.params.center_code + `/member-login/`, {
                    mobile: this.login.mobile,
                    otp: this.login.code
                })
                .then(res => {
                    if (res.data.result === true) {
                        if (this.$route.query.action == 'debit') {
                            this.$router.push('/paylink/debit/' + res.data.uuid + '/').then(() => {})
                        } else {
                            this.$router.push('/paylink/membership/' + this.membership + '/?member_login=true&member=' + res.data.uuid).then(() => {})
                        }
                    } else {
                        this.loading = false
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-center',
                            props: {
                                title: 'Error',
                                icon: 'XIcon',
                                variant: 'danger',
                                text: res.data.message
                            },
                        })
                    }
                    this.processing = false
                })
        },
        otp() {
            this.processing = true
            if (this.login.mobile === null) {
                this.$toast({
                    component: ToastificationContent,
                    position: 'top-center',
                    props: {
                        title: 'Error',
                        icon: 'XIcon',
                        variant: 'danger',
                        text: '請輸入電話號碼 Please enter mobile number'
                    },
                })
                this.processing = false
                return
            }
            this.loading = true
            this.$http.post(process.env.VUE_APP_API_BASE + `/online-pay/` + router.currentRoute.params.center_code + `/member-otp/`, {
                    mobile: this.login.mobile
                })
                .then(res => {
                    this.loading = false
                    if (res.data.result === true) {
                        this.login.sent = true
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-center',
                            props: {
                                title: '已發出驗證碼',
                                icon: 'CheckIcon',
                                variant: 'success',
                                text: '已發出驗證碼至你的whatsapp'
                            },
                        })
                    }
                    this.processing = false
                })
        },
        check_name() {
            this.processing = true
            if (this.login.member_code === null || this.login.mobile === null) {
                this.$toast({
                    component: ToastificationContent,
                    position: 'top-center',
                    props: {
                        title: 'Error',
                        icon: 'XIcon',
                        variant: 'danger',
                        text: '請輸入會員編號和電話號碼 Please enter member code and mobile number'
                    },
                })
                this.processing = false
                return
            }
            this.loading = true
            this.$http.post(process.env.VUE_APP_API_BASE + `/online-pay/` + router.currentRoute.params.center_code + `/member-check-name/`, {
                    mobile: this.login.mobile,
                    member_code: this.login.member_code
                })
                .then(res => {
                    this.loading = false
                    if (res.data.result === true) {
                        this.login.sent = true
                        this.login.zh_name = res.data.zh_name
                        this.login.en_name = res.data.en_name
                        this.login.uuid = res.data.uuid
                    } else {
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-center',
                            props: {
                                title: 'Error',
                                icon: 'XIcon',
                                variant: 'danger',
                                text: res.data.message
                            },
                        })
                    }
                    this.processing = false
                })
        },

        get_center() {
            this.$http.get(process.env.VUE_APP_API_BASE + `/client/` + router.currentRoute.params.center_code + `/`)
                .then(res => {
                    if (res.data.result === false) {
                        this.valid = false
                    } else {
                        this.loading = false
                        this.client = res.data.client
                        // 新增: 取得必填欄位
                        if (res.data.client && res.data.client.register_form_required_field) {
                            this.requiredFields = res.data.client.register_form_required_field
                        }
                    }
                })
        },

        // 新增: 判斷欄位是否必填
        isRequired(field) {
            return this.requiredFields && this.requiredFields.includes(field)
        },
        submit() {
            this.$http.post(process.env.VUE_APP_API_BASE + '/qr/register/' + router.currentRoute.params.center_code + '/', this.userData)
                .then(res => {
                    if (res.data.result === true) {
                        this.insert = true
                        //   this.$swal({
                        //     title: 'Success!',
                        //     text: '你成功註冊!',
                        //     icon: 'success',
                        //     showConfirmButton : false,
                        //     buttonsStyling: false,
                        //     backdrop: false,
                        //   })
                        this.message = res.data.message
                        if (this.membership !== null) {
                            //alert('https://www.cloudfit.pro/paylink/membership/'+this.membership+'/?member='+res.data.uuid);
                            this.$router.push('/paylink/membership/' + this.membership + '/?member=' + res.data.uuid).then(() => {})
                        }
                    } else {
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-center',
                            props: {
                                title: 'Error',
                                icon: 'XIcon',
                                variant: 'danger',
                                text: res.data.message,
                            },
                        })
                    }
                })
        },
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
